import { Controller } from 'stimulus';
import { debounce } from 'lodash-es';

// Connects to data-controller="contractors-search"
export default class extends Controller {
  static targets = ['input', 'results', 'result'];

  connect() {
    const handleInput = debounce(() => {
      this.clearContractorId();
      this.search();
    }, 800);

    this.inputTarget.addEventListener('keyup', handleInput);
    document.addEventListener('click', this.handleClickOutside.bind(this));
  }

  disconnect() {
    document.removeEventListener('click', this.handleClickOutside.bind(this));
  }

  clearContractorId() {
    if (this.inputTarget.value.trim() === "") {
      const idField = this.contractorIdField();
      if (idField) idField.value = "";
    }
  }

  search() {
    const query = this.inputTarget.value;
    if (query.length < 3) {
      this.hideResults();
      return;
    }

    fetch(`/contractors/search?query=${encodeURIComponent(query)}`, {
      method: 'GET',
      headers: { Accept: 'text/vnd.turbo-stream.html' },
    })
      .then((response) => response.text())
      .then((html) => {
        // Create an option to create a new contractor if search list is empty
        if(!html) {
          let options = document.createElement('ul');
          options.id = 'search-results-list';
          options.className = 'c-autocomplete__list';

          let createOptionContainer = document.createElement('li');
          createOptionContainer.className = 'c-autocomplete__item c-autocomplete__others';

          let createOption = document.createElement('a');
          createOption.href = '#';
          // createOption.href = '/contractors/new';
          createOption.textContent = "Can't find your contractor? Create new.";
          createOption.dataset.action = "create-contractor-display-modal";

          createOptionContainer.appendChild(createOption);
          options.appendChild(createOptionContainer);

          html = options.outerHTML;
        }
        this.resultsTarget.innerHTML = html;
      });
  }

  selectResult(event) {
    const contractor = event.currentTarget.dataset.contractor;
    const contractorId = event.currentTarget.dataset.id;
    const idField = this.contractorIdField();
    if (idField) idField.value = contractorId;
    this.inputTarget.value = contractor;
    this.hideResults();
  }

  // Prefer the hidden id field inside this controller's element so multiple
  // search fields can coexist on one page; fall back to the first on the page
  // for older single-field forms where the hidden field is a sibling.
  contractorIdField() {
    return this.element.querySelector('.js-contractor-id-target')
      || document.querySelector('.js-contractor-id-target');
  }

  handleClickOutside(event) {
    const withinComponent = this.element.contains(event.target);
    if (!withinComponent) {
      this.hideResults();
    }
  }

  hideResults() {
    this.resultsTarget.innerHTML = '';
  }
}
